(function () {
  let retries = 0;
  const maxRetries = 100; // Hasta 30s
  const waitForBoost = setInterval(() => {
    const boostReady =
      typeof SearchInput !== "undefined" &&
      typeof jQ !== "undefined" &&
      typeof boostPFSInstantSearch !== "undefined" &&
      typeof boostPFSInstantSearch.init === "function";

    if (boostReady) {
      clearInterval(waitForBoost);

      try {
        SearchInput.prototype.customizeInstantSearch = function () {
          const input = document.querySelector('input[type="search"]');
          if (input) {
            this.$element = jQ(input);
            console.log("✅ Boost selector manually overridden.");
          } else {
            console.warn("⚠️ Search input not found.");
          }
        };

        boostPFSInstantSearch.init();
        console.log("✅ Boost search manually re-initialized.");
      } catch (e) {
        console.error("⛔ Error applying Boost override:", e);
      }
    } else {
      retries++;
      if (retries % 5 === 0) {
        console.log(`⏳ Waiting for Boost libraries... (${retries})`);
      }
      if (retries >= maxRetries) {
        clearInterval(waitForBoost);
        console.warn("⛔ Boost libraries did not load in time.");
      }
    }
  }, 300);
})();

